// src/util/generateId.ts
import uniqueId from "lodash/uniqueId";
var generateId = function generateId(propsId, idPrefix) {
  return propsId || uniqueId(idPrefix);
};
export { generateId };